module.exports = __webpack_public_path__ + "img/emporte-pieces-sur-mesure.8b36fc66.jpg";